import { baseApi } from "api/BaseApi";

const ecrNotificationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    triggerNotifyEcrCommentsReleased: build.mutation<
      void,
      { product_id: number }
    >({
      query: (body) => ({
        url: "v2/notifications/ecr-comments-released/",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useTriggerNotifyEcrCommentsReleasedMutation } =
  ecrNotificationsApi;
